import React, { Component } from 'react';
import Drawer from 'rc-drawer';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { connect } from 'react-redux'
import { Button } from 'reactstrap';
import EmpList from 'components/Agile/Employee/EmpList';
import AppModuleHeader from 'components/AppModuleHeader/index';
import AddEmp from 'components/Agile/Employee/AddEmp';
import IntlMessages from 'util/IntlMessages';
import CircularProgress from 'components/CircularProgress';
import CustomScrollbars from 'util/CustomScrollbars';

import {
    addFavouriteEmp,
    fetchEmps,
    filterEmp,
    getAllEmp,
    getUnselectedAllEmp,
    handleEmpRequestClose,
    hideEmpLoader,
    showEmpLoader,
    onAddEmp,
    onAllEmpSelect,
    onEmpClose,
    onEmpSelect,
    onDeleteEmp,
    onDeleteSelectedEmp,
    onFilterEmpOptionSelect,
    onSaveEmp,
    onToggleEmpDrawer,
    updateSearchEmp
} from 'actions/Employee';


const filterOptions = [
    {
        id: 1,
        name: 'All employees',
        icon: 'zmdi-menu'
    }, {

        id: 2,
        name: 'Starred employees',
        icon: 'zmdi-star'
    }
];

class Employee extends Component {

    EmpSideBar = () => {
        return <div className="module-side">
            <div className="module-side-header">
                <div className="module-logo">
                    <i className="zmdi zmdi-city-alt mr-4" />
                    <span><IntlMessages id="sidebar.employees" /></span>
                </div>
            </div>


            <div className="module-side-content">
                <CustomScrollbars className="module-side-scroll scrollbar"
                    style={{ height: this.props.width >= 1200 ? 'calc(100vh - 200px)' : 'calc(100vh - 80px)' }}>
                    <div className="module-add-task">
                        <Button className="btn-block jr-btn" color="primary"
                            onClick={this.onAddEmp}>
                            <i className="zmdi zmdi-accounts-add zmdi-hc-fw" />
                            <span>Add New Employee</span>
                        </Button>
                    </div>
                    <div className="module-side-nav">
                        <ul className="module-nav">
                            {filterOptions.map(option => <li key={option.id} className="nav-item">
                                <a href="javascript:void(0)"
                                    className={option.id === this.props.selectedSectionId ? 'active' : ''} onClick={
                                        this.onFilterEmpOptionSelect.bind(this, option)
                                    }>
                                    <i className={`zmdi ${option.icon}`} />
                                    <span>{option.name}</span>
                                </a>
                            </li>
                            )}

                        </ul>
                    </div>
                </CustomScrollbars>
            </div>
        </div>;
    };

    addFavouriteEmp = (data) => {
        this.props.addFavouriteEmp(data);
    };
    onEmpSelect = (data) => {
        this.props.onEmpSelect(data);
    };

    onAddEmp = () => {
        this.props.onAddEmp();
    };
    onEmpClose = () => {
        this.props.onEmpClose();
    };
    onFilterEmpOptionSelect = (option) => {
        this.props.onFilterEmpOptionSelect(option);
    };
    onSaveEmp = (data) => {
        this.props.onSaveEmp(data);
    };
    onDeleteEmp = (data) => {
        this.props.onDeleteEmp(data);
    };
    onDeleteSelectedEmp = () => {
        this.props.onDeleteSelectedEmp();
    };
    filterEmp = (empName) => {
        if (empName === '') {
            this.onFilterEmpOptionSelect(this.props.filterOption);
        } else {
            this.props.filterEmp(empName);
        }
    };
    handleEmpRequestClose = () => {
        this.props.handleEmpRequestClose();
    };
    getAllEmp = () => {
        this.props.getAllEmp();
    };
    getUnselectedAllEmp = () => {
        this.props.getUnselectedAllEmp();
    };
    onAllEmpSelect = () => {
        const selectAll = this.props.selectedEmps < this.props.empList.length;
        if (selectAll) {
            this.props.getAllEmp();
        } else {
            this.props.getUnselectedAllEmp();
        }
    };
    onToggleEmpDrawer = () => {
        this.props.onToggleEmpDrawer();
    };
    showEmpLoader = () => {
        this.props.showEmpLoader();
    }

    constructor() {
        super();
    }

    componentDidMount() {
        this.props.showEmpLoader();
        this.props.fetchEmps();
    }


    updateSearchEmp(evt) {
        this.props.updateSearchEmp(evt.target.value);
        this.props.filterEmp(evt.target.value);
    }

    render() {
        const {
            width,
            emp,
            org,
            empList,
            addEmpState,
            selectedEmps,
            alertMessage,
            showMessage,
            drawerState,
            noContentFoundMessage,
            loader,
            searchEmp,
        } = this.props;
        return (
            <div className="app-wrapper">
                <div className="app-module animated slideInUpTiny animation-duration-3">

                    <div className="d-block d-xl-none">
                        <Drawer
                            touch={true}
                            transitions={true}
                            enableDragHandle={true}
                            open={drawerState}
                            onOpenChange={this.onToggleEmpDrawer.bind(this)}
                            sidebar={this.EmpSideBar(emp)} />
                    </div>
                    <div className="app-module-sidenav d-none d-xl-flex">
                        {this.EmpSideBar(emp)}
                    </div>

                    <div className="module-box">
                        <div className="module-box-header">
                            <span className="icon-btn drawer-btn d-flex d-xl-none"
                                onClick={this.onToggleEmpDrawer.bind(this)}>
                                <i className="zmdi zmdi-menu" />
                            </span>
                            <AppModuleHeader placeholder="Search employees" notification={false} apps={false}
                                user={org}
                                onChange={this.updateSearchEmp.bind(this)}
                                value={searchEmp} />
                        </div>
                        <div className="module-box-content">

                            <div className="module-box-topbar align-items-center">
                                <div className="form-control-checkbox d-flex">
                                    <div className="form-checkbox">
                                        <input type="checkbox"
                                            checked={selectedEmps > 0}
                                            onChange={this.onAllEmpSelect.bind(this)} />
                                        <span className="check">
                                            <i className="zmdi zmdi-check zmdi-hc-lg" />
                                        </span>
                                    </div>
                                </div>
                                <Button size="sm" className="jr-btn jr-flat-btn" color="default"
                                    onClick={this.onDeleteSelectedEmp.bind(this)} >
                                    <i className="zmdi zmdi-filter-list zmdi-hc-fw" />
                                    <span><IntlMessages id="label.filter.selected" /></span>
                                </Button>
                            </div>
                            <CustomScrollbars className="module-list-scroll scrollbar"
                                style={{ height: this.props.width >= 1200 ? 'calc(100vh - 265px)' : 'calc(100vh - 245px)' }}>
                                {loader ?
                                    <div
                                        className="loader-view-block h-100">
                                        <div className="loader-view">
                                            <CircularProgress />
                                        </div>
                                    </div>
                                    :
                                    empList && empList.length === 0 ?
                                        <div className="h-100 d-flex align-items-center justify-content-center">
                                            {noContentFoundMessage}
                                        </div>
                                        : <EmpList data={empList}
                                            width={width}
                                            addFavouriteEmp={this.addFavouriteEmp.bind(this)}
                                            onEmpSelect={this.onEmpSelect.bind(this)}
                                            onDeleteEmp={this.onDeleteEmp.bind(this)}
                                            onSaveEmp={this.onSaveEmp.bind(this)}
                                            showEmpLoader={this.showEmpLoader.bind(this)} />
                                }
                            </CustomScrollbars>

                        </div>
                    </div>
                </div>
                <AddEmp
                    open={addEmpState}
                    employee={{
                        'id': '',
                        'name': '',
                        'thumb': null,
                        'email': '',
                        'phone': '',
                        'designation': '',
                        'selected': false,
                        'starred': false,
                        'frequently': false,
                        'password': '',
                        role: ''
                    }}
                    onSaveEmp={this.onSaveEmp}
                    onEmpClose={this.onEmpClose}
                    onDeleteEmp={this.onDeleteEmp}
                    showEmpLoader={this.showEmpLoader}
                />

                {showMessage && NotificationManager.success(alertMessage, this.handleEmpRequestClose())}
                <NotificationContainer />

            </div>
        )
    }
}


const mapStateToProps = ({ emps, settings, orgs }) => {
    const { width } = settings;
    const {
        org,
    } = orgs;
    const {
        loader,
        alertMessage,
        showMessage,
        noContentFoundMessage,
        selectedSectionId,
        drawerState,
        emp,
        searchEmp,
        filterOption,
        allEmp,
        empList,
        selectedEmp,
        selectedEmps,
        addEmpState
    } = emps;
    return {
        width,
        loader,
        alertMessage,
        showMessage,
        noContentFoundMessage,
        selectedSectionId,
        drawerState,
        emp,
        searchEmp,
        filterOption,
        allEmp,
        empList,
        selectedEmp,
        selectedEmps,
        addEmpState,
        org,
    };
};
export default connect(mapStateToProps, {
    fetchEmps,
    addFavouriteEmp,
    onEmpSelect,
    onAddEmp,
    onEmpClose,
    onFilterEmpOptionSelect,
    onSaveEmp,
    onDeleteEmp,
    onDeleteSelectedEmp,
    filterEmp,
    getAllEmp,
    getUnselectedAllEmp,
    onAllEmpSelect,
    updateSearchEmp,
    onToggleEmpDrawer,
    handleEmpRequestClose,
    hideEmpLoader,
    showEmpLoader
})(Employee);


// WEBPACK FOOTER //
// ./components/Agile/employee/index.js